export const GROUP_LABLES = {
  global: `General`,
  dashboard: "Dashboard",
  question: "Querying & the notebook",
  collection: "Collection",
};
